module.exports = __webpack_public_path__ + "24c03b97833279a48ecadc0a06efaf74.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatitle/KomikaTitle-webfont.ttf
// module id = 235
// module chunks = 0